//NPM
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { filter, find, isEmpty, map } from "lodash";

// ANTD
import { Col, Row, Checkbox, Steps } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";

// SHARED COMPONENTS
import { Button, Tabs, TextInput } from "@life-line-lab/components-react";

// HOOKS
import { useQuery, useSession } from "Hooks/index";

// STYLESHEETS
import "./control-tower.scss";
import nextbillion, { Marker, NBMap, Popup } from "@nbai/nbmap-gl";

const { roleTypes } = useSession();
const isRoleCustomer = roleTypes == "CUSTOMER-SUPER_ADMIN" && true;

interface LastMileCTProps {
  lastMileData?: any;
}
const ControlTowerLastMileView: React.FC<LastMileCTProps> = ({ lastMileData }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [selectedTasks, setSelectedTasks] = useState([]);
  const checkBoxChange = (e: CheckboxChangeEvent) => {
    const taskId: any = e.target.id;
    const isChecked: Boolean = e.target.checked;
    setSelectedTasks((prev) => {
      return {
        ...prev,
        [taskId]: isChecked,
      };
    });
  };
  const query = useQuery();
  const tabKey = "0";
  const [tabActiveKey, setTabActiveKey] = useState(tabKey);
  const [forceRender, setForceRender] = useState<boolean>(false);

  const [tasks, setTasks] = useState<any>(lastMileData);

  const addSimpleMarker = (nbmap, long, lat, markerName) => {
    // if(long > -90 || long < 90 ){
    //   return
    // }else{
    //   console.log(lat,long)
    //
    // }
    const popup = new Popup({ offset: 25, closeButton: false }).setText(markerName);
    const marker = new Marker().setLngLat({ lat: long, lng: lat }).setPopup(popup).addTo(nbmap.map);
    marker.togglePopup();
  };

  useEffect(() => {
    nextbillion.setApiKey(`${process.env.NEXT_BILLION_KEY}`);

    let filteredSelectedTasks = filter(selectedTasks, (value, k) => {
      return value == true;
    });

    if (filteredSelectedTasks?.length != 0) {
      const nbmap = new NBMap({
        container: "map",
        style: "https://api.nextbillion.io/maps/streets/style.json",
        zoom: 8,
        center: { lat: 3.164005474252092, lng: 101.65040013068355 },
      });
      map(tasks, (taskObj) => {
        let selectedTaskObj = find(selectedTasks, (val, k) => {
          return k == taskObj.orderID && val == true;
        });
        if (selectedTaskObj) {
          return map(taskObj.parcelList, (tsk, i) => {
            if (tsk?.location?.coordinate) {
              return addSimpleMarker(
                nbmap,
                tsk?.location?.coordinate?.lat,
                tsk?.location?.coordinate?.lon,
                tsk.orderCode,
              );
            }
          });
        }
      });
    } else {
      const nbmap = new NBMap({
        container: "map",
        style: "https://api.nextbillion.io/maps/streets/style.json",
        zoom: 8,
        center: { lat: 3.164005474252092, lng: 101.65040013068355 },
      });
      map(tasks, (taskObj) => {
        return map(taskObj.parcelList, (tsk, i) => {
          if (tsk?.location?.coordinate) {
            return addSimpleMarker(
              nbmap,
              tsk?.location?.coordinate?.lat,
              tsk?.location?.coordinate?.lon,
              tsk.orderCode,
            );
          }
        });
      });
    }

    // addDraggableMarker(nbmap)
    // addCustomMarkerWithDom(nbmap)
  }, [tasks, selectedTasks]);

  let tabs = [
    {
      tabKey: "0",
      label: t("tab.all"),
      component: null,
    },
  ];

  tabs = !isRoleCustomer
    ? tabs.concat([
        {
          tabKey: "1",
          label: t("tab.ongoing"),
          component: null,
        },
        {
          tabKey: "2",
          label: t("tab.planned"),
          component: null,
        },
      ])
    : tabs;

  const handleTabClick = (key) => {
    setTabActiveKey(key);
    setForceRender(true);
  };

  useEffect(() => {
    if (tabActiveKey === "0") {
      setTasks(lastMileData);
    } else if (tabActiveKey === "1") {
      let onGoingData: any = filter(lastMileData, (midMileObj) => {
        return midMileObj.tripStatus !== "PLANNED";
      });
      setTasks(onGoingData);
    } else if (tabActiveKey === "2") {
      let plannedData: any = filter(lastMileData, (midMileObj) => {
        return midMileObj.tripStatus === "PLANNED";
      });
      setTasks(plannedData);
    }
  }, [tabActiveKey, lastMileData]);

  return (
    <div>
      <div className="control-tower">
        <Row>
          <Col xs={24} sm={24} md={18} xl={16} xxl={18}>
            {/*<img src="/assets/images/map-placeholder.png" className="map-placeholder"></img>*/}
            <div
              style={{
                width: "100%",
                minHeight: "500px",
                height: "auto",
                // position: 'fixed',
                // top: '0',
                // left: '0'
              }}
              id="map"
            ></div>
          </Col>
          <Col xs={24} sm={24} md={6} xl={8} xxl={6} className="task-menu">
            <h2>{t("label.deliveryTasks")}</h2>
            <Row>
              <Col xs={12} sm={12} md={24} xl={24}>
                <Tabs
                  destroyInactiveTabPane={true}
                  onTabClick={handleTabClick}
                  defaultActiveKey="0"
                  activeKey={tabActiveKey}
                  tabBarGutter={25}
                  tabs={tabs}
                />
              </Col>
            </Row>
            <div className="right-bar">
              <div>
                <Checkbox disabled={false} indeterminate={true} checked={true}>
                  <div style={{ position: "relative" }}>
                    <p>All</p>
                  </div>
                </Checkbox>
              </div>
              <div>
                {tasks.length ? (
                  map(tasks, (task, index) => {
                    return (
                      <Row>
                        <Col
                          xs={16}
                          sm={16}
                          md={16}
                          xl={16}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Checkbox
                            disabled={false}
                            checked={selectedTasks[task.orderID]}
                            name="diolkoServicePoints"
                            onChange={checkBoxChange}
                            style={{ marginRight: 10 }}
                            id={task.orderID}
                          ></Checkbox>
                          <span
                            className="checkbox-marker"
                            style={{ marginLeft: "25px", background: "#469A12" }}
                          ></span>
                          <span style={{ marginLeft: "20px" }}>{task.code}</span>
                        </Col>
                        <Col xs={8} sm={8} md={8} xl={8} className="driver">
                          {task.driverName}
                        </Col>
                      </Row>
                    );
                  })
                ) : (
                  <></>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ControlTowerLastMileView;
